module.exports = __webpack_public_path__ + "img/forget-passwordUA.e1d40be1.png";